<div class="alert-dialog">
  <div class="alert-dialog__close" (click)="close()"><i class="material-icons md-18">close</i></div>
  <div class="alert-dialog__text">{{alertText}}</div>
  <div class="alert-dialog__open" (click)="open()">Go to TAP</div>
</div>